import { LS_CHAT_LOAD_PREFERENCE_KEY } from './private';

/**
 * Returns a site-scoped localStorage key for storing the last selected conversation.
 * This ensures conversation restoration is scoped to the correct site when the chat
 * is remounted with a different siteId.
 */
export const getChatLoadPreferenceKey = (siteId: string): string =>
	siteId ? `${LS_CHAT_LOAD_PREFERENCE_KEY}_${siteId}` : LS_CHAT_LOAD_PREFERENCE_KEY;
